import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' }
});

// Attach JWT token if present
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Stocks
export const stocksApi = {
  getAll: (params = {}) => api.get('/stocks', { params }),
  getOne: (id) => api.get(`/stocks/${id}`),
  create: (data) => api.post('/stocks', data),
  delete: (id) => api.delete(`/stocks/${id}`)
};

// Transactions
export const transactionsApi = {
  getByStock: (stockId, params = {}) => api.get(`/transactions/${stockId}`, { params }),
  create: (data) => api.post('/transactions', data),
  update: (id, data) => api.put(`/transactions/${id}`, data),
  delete: (id) => api.delete(`/transactions/${id}`)
};

// Auth
export const authApi = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data)
};

export default api;
